export default __webpack_public_path__ + "static/playground-bg-CTA-9d08908a6d6d4c0645830e2f80875325.png";